import React from 'react'
import Item from '../Item'
import Modal from './Modal';

const BackLog = ({data,InnerRef}) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
        <div ref={InnerRef} className="flex flex-col flex-shrink-0 w-72">
            <div className="flex items-center flex-shrink-0 h-10 px-2">
                <span className="block text-sm font-semibold">Backlog</span>
                <span
                    className="flex items-center justify-center w-5 h-5 ml-2 text-sm font-semibold text-indigo-500 bg-white rounded bg-opacity-30"
                    >{data.filter((item,i)=>item.stage==='backlog').length}</span>
                <button
                    className="flex items-center justify-center w-6 h-6 ml-auto text-indigo-500 rounded hover:bg-indigo-500 hover:text-indigo-100"
                    onClick={()=>setShowModal(true)}
                >
                    <svg
                        className="w-5 h-5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                        ></path>
                    </svg>
                </button>
            </div>
            <div className="flex flex-col pb-2 overflow-auto pt-4">
                
                {data && data.length > 0 && data.map((item,i)=>(
                    item.stage==='backlog' &&
                     <Item  playerType="backlog"
                            index={item.id} 
                            key={i} 
                            backlog={true}
                            item={item}
                            />
                  ))
                }
               
            </div>

            {showModal ? (<Modal setShowModal={setShowModal} />) : null}

        </div>
  )
}

export default BackLog